module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_prokaryotic_chromosome_1-a40387ee112b984e19951fbe07f4ab40.jpg";